import React from 'react';
import PropTypes from 'prop-types';
import ValidatingForm from '../forms/validating_form';
import TextField from '../fields/text_field';
import StateSelector from '../fields/state_selector';
import PostalCodeField from '../fields/postal_code_field';
import PhoneField from '../fields/phone_field';
import CountrySelector from '../fields/country_selector';

class Address extends ValidatingForm {
  componentDidUpdate(prevProps, prevState){
    if(JSON.stringify(this.state.erroredFields) !== JSON.stringify(prevState.erroredFields)){
      this.props.updateFormError(this._reactInternalFiber.type.name.toLowerCase(), this.state.erroredFields)
    }
  }
  requiredFieldNames() {
    return [
      'street_address',
      'city',
      'state_id',
      'zip',
      'country_id',
      'phone',
    ];
  }


  render() {
    return (
      <div id='address_form'>
        <div className='input-error'>{ this.state.errorMessage }</div>
        <form className='ordination-form'>
          <h3 className='form-section-title'>Your Full Street Address</h3>
          <div className='l-row'>
            <TextField
              required
              name='street_address'
              displayName='Street'
              updateModel={ this.props.updateModel }
              updateErrorMessage={ this.updateErrorMessage }
              value={ this.props.minister.street_address }
              onError={ this.addError }
              onValid={ this.removeError }
              className='l-columns-600-12'/>
            <TextField
              required
              name='city'
              displayName='City'
              updateModel={ this.props.updateModel }
              updateErrorMessage={ this.updateErrorMessage }
              value={ this.props.minister.city }
              onError={ this.addError }
              onValid={ this.removeError }
              className='l-columns-600-4'/>
            <StateSelector
              required
              selectedCountry={ this.props.minister.country_id }
              name='state_id'
              displayName='State'
              updateModel={ this.props.updateModel }
              updateErrorMessage={ this.updateErrorMessage }
              value={ this.props.minister.state_id }
              onError={ this.addError }
              onValid={ this.removeError }
              className='l-columns-600-4'/>
            <CountrySelector
              required
              name='country_id'
              displayName='Country'
              updateModel={ this.props.updateModel }
              updateErrorMessage={ this.updateErrorMessage }
              value={ this.props.minister.country_id }
              onError={ this.addError }
              onValid={ this.removeError }
              className='l-columns-600-4'/>
            <PostalCodeField
              required
              name='zip'
              displayName='Zip/Postal Code'
              updateModel={ this.props.updateModel }
              updateErrorMessage={ this.updateErrorMessage }
              validate={ this.isAmerican(this.props.minister.country_id) }
              value={ this.props.minister.zip }
              onError={ this.addError }
              onValid={ this.removeError }
              className='l-columns-600-4'/>
            <PhoneField
              required
              name='phone'
              displayName='Phone'
              updateModel={ this.props.updateModel }
              updateErrorMessage={ this.updateErrorMessage }
              value={ this.props.minister.phone }
              onError={ this.addError }
              onValid={ this.removeError }
              className='l-columns-600-4'/>
          </div>
        </form>
      </div>
    );
  }
}


Address.propTypes = {
  minister: PropTypes.object.isRequired,
  updateModel: PropTypes.func.isRequired,
};

export default Address;
